<template>
  <div class="home-wrap">
    <div class="top-welcome">
      欢迎来到亿尚官网管理后台
    </div>
  </div>
</template>

<script>
  export default {
    name: 'homeIndex',
    data() {
      return {
       
      }
    },
    created() {
     
    },
    methods: {
      
    }
  }
</script>

<style scoped lang="scss">
.home-wrap {
  margin: 16px 16px 0;
  padding: 16px;
  box-sizing: border-box;
  background: #fff;
  height: -moz-calc(100vh - 96px);
  height: -webkit-calc(100vh - 96px);
  height: calc(100vh - 96px);
  .top-welcome {
    padding-top: 10%;
    text-align: center;
    font-size: 36px;
    color: #333;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue